var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9099 1.71452C40.0008 1.48736 40.0231 1.2385 39.9739 0.998814C39.9248 0.759123 39.8063 0.539133 39.6333 0.366117C39.4603 0.193101 39.2403 0.074667 39.0006 0.0254984C38.7609 -0.0236702 38.5121 -0.00141148 38.2849 0.0895152L1.91742 14.637H1.91492L0.784921 15.087C0.570897 15.1724 0.384635 15.3153 0.24671 15.4998C0.108786 15.6844 0.0245663 15.9035 0.00335492 16.133C-0.0178564 16.3624 0.0247659 16.5933 0.126514 16.8C0.228262 17.0068 0.385175 17.1814 0.579921 17.3045L1.60492 17.9545L1.60742 17.9595L14.0949 25.9045L22.0399 38.392L22.0449 38.397L22.6949 39.422C22.8185 39.616 22.9932 39.7722 23.1998 39.8733C23.4063 39.9744 23.6368 40.0165 23.8658 39.9951C24.0948 39.9736 24.3135 39.8894 24.4977 39.7517C24.6819 39.614 24.8245 39.4281 24.9099 39.2145L39.9099 1.71452ZM35.3274 6.43952L16.5924 25.1745L16.0549 24.3295C15.9564 24.1745 15.825 24.043 15.6699 23.9445L14.8249 23.407L33.5599 4.67202L36.5049 3.49452L35.3274 6.43952Z",
    fill: "url(#paint0_linear_14383_46084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14383_46084",
    x1: -0.452129,
    y1: 20.3639,
    x2: 40.7712,
    y2: 20.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00954A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02BA53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestSendIcon);
export default __webpack_public_path__ + "static/media/request_send_icon.cb9573c3b4d6cd92921441bf303fc32b.svg";
export { ForwardRef as ReactComponent };